import { ChevronRight } from "zudoku/icons";
import { useLocation } from "zudoku/router";
import { products } from "./products.js";
import "./docs-article.css";

const useProductName = () => {
  const { pathname } = useLocation();
  const id = pathname.split("/")[1];
  return (
    products.find((product) => product.id === id)?.name ??
    (id === "products" ? "社交娱乐产品体系" : "服务支持")
  );
};
export const DocsBreadcrumb = () => {
  const name = useProductName();
  return (
    <nav className="ax-article-breadcrumb" aria-label="面包屑">
      <a href="/overview">文档中心</a>
      <ChevronRight size={12} />
      <span>{name}</span>
      <ChevronRight size={12} />
      <span>产品文档</span>
    </nav>
  );
};
export const DocsSidebarHeading = () => (
  <div className="ax-article-sidebar-title">
    {useProductName()}
    <span>产品文档</span>
  </div>
);
export const DocsArticleSupport = () => (
  <div className="ax-article-support">
    <span>需要产品演示或更多技术资料？</span>
    <a href="/support">联系产品顾问 →</a>
  </div>
);
